/**
 * Heavy libraries that only an import / export click needs. Loading them at
 * the top of a helper put ExcelJS (~900 KB) and JSZip in the download of every
 * page that merely imports the helper (the leads page, the dashboard's leads
 * preload); here they load on first use instead, then stay cached.
 */
export const loadExcelJS = async () => (await import("exceljs")).default;
export const loadJSZip = async () => (await import("jszip")).default;
